import type { ChatSuggestion } from "@repo/ui/chat/chatEmptyState";

// Shared research, clarification, testing, and proposal rules live in
// getSignalConfigurationInstructionsTool; starters supply only the task.
const DRAFT_OBJECTIONS_SIGNAL_PROMPT = `Draft a customer objections signal for me, with examples of what should and should not match and useful metadata for analyzing objection types.`;

const REVIEW_SIGNAL_PROMPT = `Review this signal definition for clarity and effectiveness. Identify ambiguous matching criteria, missing exclusions, or relevant variations it may miss, and recommend any supported improvements.`;

const REVIEW_METADATA_PROMPT = `Review the metadata this signal extracts. Assess whether fields are reliably extractable when applicable, whether enum options cover observed categories, and whether useful recurring information is missing. Recommend any supported improvements.`;

/**
 * The signals list's draft starter. The reply asks what to detect before the
 * agent runs, so it starts from the user's answer rather than a guess.
 */
export const signalsListSuggestions: ChatSuggestion[] = [
  {
    label: "Help draft a signal",
    prompt: "Help me draft a signal.",
    reply: `I can help you draft a signal. What would you like to find in calls?
1. Customer objections or pushback
2. Mentions of a competitor, product, or policy
3. A step reps should cover on every call

Pick one, or describe the pattern you have in mind, and I'll draft it for you to review.`,
  },
];

/** Signal drafting and review starters for the signal editor. */
export function getSignalConfigSuggestions(args: {
  isNewSignal: boolean;
}): ChatSuggestion[] {
  if (args.isNewSignal) {
    return [
      {
        label: "Draft a customer objections signal",
        prompt: DRAFT_OBJECTIONS_SIGNAL_PROMPT,
      },
    ];
  }
  return [
    {
      label: "Review this signal for improvements",
      prompt: REVIEW_SIGNAL_PROMPT,
    },
    {
      label: "Review the metadata fields this signal extracts",
      prompt: REVIEW_METADATA_PROMPT,
    },
  ];
}
